import styles from "./ModalNotificacion.module.css";

export default function ModalNotificacion({ mensaje, visible, tipo = "success", onClose }) {
  if (!visible) return null;

  return (
    <div className={styles.overlay}>
      <div className={`${styles.modal} ${styles[tipo]}`}>
        <p>{mensaje}</p>
        <button onClick={onClose}>Cerrar</button>
      </div>
    </div>
  );
}
